import { Button, makeStyles } from "@material-ui/core";
import {
  CreateOutlined,
  DeleteOutlineOutlined,
  LocalPrintshopOutlined,
} from "@material-ui/icons";
import React from "react";

const useStyles = makeStyles((theme) => ({
  row: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    marginTop: 6,
  },
  button: {
    flex: "1 1 120px",
    width: "auto",
    minWidth: "min(100%, 120px)",
    minHeight: 48,
    padding: "8px 12px",
    textTransform: "none",
  },
  cancel: {
    color: theme.palette.error.dark,
  },
}));

type Props = {
  onPrint?: () => void;
  onEdit: () => void;
  onCancel: () => void;
};

export const KitchenOrderActions: React.FC<Props> = ({
  onPrint,
  onEdit,
  onCancel,
}) => {
  const styles = useStyles();

  return (
    <div className={styles.row}>
      {onPrint && (
        <Button className={styles.button} variant="outlined" startIcon={<LocalPrintshopOutlined />} onClick={onPrint}>
          Imprimir
        </Button>
      )}
      <Button className={styles.button} variant="outlined" startIcon={<CreateOutlined />} onClick={onEdit}>
        Editar
      </Button>
      <Button className={`${styles.button} ${styles.cancel}`} variant="outlined" startIcon={<DeleteOutlineOutlined />} onClick={onCancel}>
        Cancelar
      </Button>
    </div>
  );
};
